import { action, observable, toJS } from 'mobx';
import urlQueryParams from 'webPosApp/helpers/urlQueryParams';
import { http, ResponseWrapper } from 'webPosApp/api';
import StoreModel from 'webPosApp/models/Index';
import QueryParams from 'webPosApp/helpers/QueryParams';
import { ConfirmRequest } from 'shared/interfaces/webPosSdk/ConfirmRequest';
import { ConfirmationInfoType, ItemType } from 'shared/interfaces/webPosSdk/IConfirmationInfoType';

export class Confirmation {
    private root: StoreModel;
    @observable.shallow transactionLineItems: any;
    @observable posOrderID: any;

    constructor(root: StoreModel) {
        this.root = root;
    }

    get startUrl() { return window.location.href }


    @action findProductBySku = async (sku: string) => {
        const { isSuccess, postData = [] } = await this.root.posSdk.findProductBySku(sku);

        if (!isSuccess || !postData[0]) {
            return;
        }
        return postData[0];
    }

    @action confirmPayment = async (
        request: PaymentRequest
    ): Promise<ResponseWrapper<PaymentResponse>> => {
        const response = await http.post<ResponseWrapper<PaymentResponse>>(
            'api/amdocs/payment',
            request
        );

        return response.data;
    };

    @action addProductToCart = async () => {
        const product =  await this.findProductBySku(this.root.sku!);

        product.appId = this.root.appId;
        product.isVoidable = false;
        product.isReturnable = false;
        product.unitPrice = this.root.billpay.customer?.totalDueAmount;

        const externalServiceInfo = {
            kioskId: this.root.deviceId,
            accountNumber: this.root.billpay.customer?.accountNumber
        } as ExternalServiceInfo
        product.externalServiceInfo = JSON.stringify(externalServiceInfo);

        return await this.root.posSdk.addProductLineItemsToCart(product);
    }
    
    

    @action confirmSuccess = async () => {
        const successData = {
            externalOrderId: this.posOrderID,
            transactionLineItemsResponse: toJS(this.transactionLineItems),
        };

        const confirmationData = {
            result: 'success',
            successData,
        } as ConfirmRequest;

        this.root.posSdk.confirmSuccess(confirmationData); 
    }

    @action confirmFailed = async () => {
        const successData = {
            externalOrderId: this.posOrderID,
            transactionLineItemsResponse: toJS(this.transactionLineItems),
        };

        const confirmationData = {
            result: 'failed',
            successData,
        } as ConfirmRequest;

        this.root.posSdk.confirmFailed(confirmationData); 
    }
    
    @action setTransactionLineItems = (items: any) => {
        return this.transactionLineItems = items;
    }
    
    @action setPosOrderId = (posOrderId: any) => {
        return this.posOrderID = posOrderId;
    }

    getConfirmationInfo = async () => {
        let bundleId: any = null;
        let transactionLineItemId: any = null;
        let cartBundleId: any = null;

        const startQueryParams = urlQueryParams(this.startUrl);

        const { [QueryParams.ProductLineItemId]: confirmationId } = startQueryParams;

        transactionLineItemId = confirmationId;

        const { postData } = await this.root.posSdk.getConfirmationInfo({
            bundleId,
            transactionLineItemId,
            cartBundleId,
        })

        const { posOrderID, items }  = this.parseConfirmInfo(postData.data);
        
        this.setTransactionLineItems(items);
        this.setPosOrderId(posOrderID);
    }

    public parseConfirmInfo = (data: any): ConfirmationInfoType => {
        return {
            posOrderID: data?.posOrderID,
            items: data?.transactionLineItems.map(lineItem => {                
                return this.parseLineItem(lineItem);
            })
        };
    }

    public parseLineItem = (lineItem: any): ItemType => {
        const externalServiceInfo = lineItem.externalServiceInfo ?
            JSON.parse(lineItem.externalServiceInfo) : null;

        const {  kioskId, accountNumber } = externalServiceInfo || {};

        return {
            extServiceInfo: externalServiceInfo,
            kioskId: kioskId ?
                JSON.parse(kioskId) : null,
            accountNumber: accountNumber ?
                JSON.parse(accountNumber) : null,
            lineItem,
        };
    }

    getConfirmDetails = async () => {

        const lineItem = this.transactionLineItems.items?.find((i: { lineItem: { sku: string; }; }) => i.lineItem.sku === this.root.sku!);

        return {
            kioskId: lineItem?.kioskId || null,
            accountNumber: lineItem?.accountNumber || null,
            paymentAmount: lineItem.unitPrice
        } as unknown as PaymentRequest
    }
} 

export interface PaymentRequest {
    kioskId: string | undefined;
    accountNumber: string | undefined; 
    payAmount: number | undefined; 
}

export interface PaymentResponse {
    
}

export interface ExternalServiceInfo {
    kioskId: string;
    accountNumber: string;
}